@switch (steg()) {
  @case ('velgeid') {
    @if (popupBlokkert()) {
      <inline-melding type="feil">
        {{ 'Kunne ikke åpne popup-vindu med BankId-dialog, har du en popupblokker aktivert?'|translate }}
      </inline-melding>
    }

    @if (erNoBankidTilgjengelig()) {
      <div class="knapp" (click)="velgNoBankid()" data-testid="nobankid">
        <img [src]="noBankidLogoBilde">
        <div>{{ 'Norsk BankID'|translate }}</div>
      </div>
    }
    @if (erSeBankidTilgjengelig()) {
      <div class="knapp" (click)="velgSeBankid()" data-testid="sebankid">
        <img [src]="seBankidLogoBilde">
        <div>{{ 'Svensk BankID'|translate }}</div>
      </div>
    }
  }
  @case ('velgsvenskeid') {
    <div class="knapp" (click)="velgSeBankidSamedevice()" data-testid="sebankid-samedevice">
      <img [src]="seBankidLogoBilde">
      <div>
        <div>{{ 'Svensk BankID'|translate }}</div>
        <div>{{ 'På denne enheten'|translate }}</div>
      </div>
    </div>
    <div class="knapp" (click)="velgSeBankidAnotherdevice()" data-testid="sebankid-anotherdevice">
      <img [src]="seBankidLogoBilde">
      <div>
        <div>{{ 'Svensk BankID'|translate }}</div>
        <div>{{ 'Med personnummer'|translate }}</div>
      </div>
    </div>
    <div class="knapp" (click)="velgSeBankidAnotherdeviceqr()" data-testid="sebankid-anotherdeviceqr">
      <img [src]="seBankidLogoBilde">
      <div>
        <div>{{ 'Svensk BankID'|translate }}</div>
        <div>{{ 'Med QR-kode'|translate }}</div>
      </div>
    </div>
    <button mat-button (click)="tilbakeTilVelgEid()">
      {{ 'Tilbake'|translate }}
    </button>
  }

  <!-- e-id valgt - redirigerer til oidc-tilbyder -->
  @case ('visbankiddialog') {
    <div class="beskjed" data-testid="laster">
      <p>{{ 'Følg instruksjonene i BankID popup-vinduet...'|translate }}</p>
    </div>
  }

  <!-- mens vi håndtere callbacket fra criipto -->
  @case ('callbakmottatt') {
    <div class="beskjed">
      <mat-progress-spinner mode="indeterminate" diameter="40"/>
      <p>{{ 'Autentiserer'|translate }}...</p>
    </div>
  }
}
